export const testimonials = [
  {
    quote: "Ready to serve you with IT support, IoT solutions, and software integration.",
    name: "Ahmed Attwi",
    position: "IT Specialist and Software Developer",
    avatar: require('../assets/testimonials/ahmad.jpeg')
  },
];
